module.exports = __webpack_public_path__ + "static/media/HourGlass.410f4314.svg";